import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import load from './load';
export var nextPage = function nextPage(props) {
  return function (dispatch, getState) {
    var id = props.id;
    var store = getState();
    var view = store.grid.views[id];
    var oldPage = view.page || 0;
    return dispatch(load(_objectSpread({}, props, {
      page: oldPage + 1,
      id: id
    })));
  };
};
export var prevPage = function prevPage(props) {
  return function (dispatch, getState) {
    var id = props.id;
    var store = getState();
    var view = store.grid.views[id];
    var oldPage = view.page || 0;
    if (view.page === 0) oldPage = 1;
    return dispatch(load(_objectSpread({}, props, {
      page: oldPage - 1,
      id: id
    })));
  };
};
export var gotoPage = function gotoPage(props) {
  return function (dispatch) {
    var id = props.id,
        page = props.page;
    return dispatch(load(_objectSpread({}, props, {
      page: page,
      id: id
    })));
  };
};
export var changeItemsPerPage = function changeItemsPerPage(options) {
  return function (dispatch) {
    var id = options.id,
        itemsPerPage = options.itemsPerPage;
    return dispatch(load(_objectSpread({}, options, {
      itemsPerPage: itemsPerPage,
      id: id
    })));
  };
};
export default {
  nextPage: nextPage,
  prevPage: prevPage,
  gotoPage: gotoPage,
  changeItemsPerPage: changeItemsPerPage
};